<template>
    <div class="danmaku-panel">
        <!-- <header class="head">
            <strong>弹幕</strong>
            <span class="state" :class="state">{{ state.toUpperCase() }}</span>
        </header> -->
        <slot name="PurchaseTicker"></slot>
        <section class="list" ref="list">
            <div v-if="historyLoading" class="history-loading-tip">
                <i class="el-icon-loading"></i>
                <span>{{ readonlyHistory ? '正在加载历史弹幕...' : '正在补充历史弹幕...' }}</span>
            </div>
            <div class="enter_msg">
                <div v-for="item in enter_msg" :key="item.id" class="msg">
                    <span class="uid">{{ displayNickname(item) }}</span>
                    <span class="platform-tag" :style="platformTagStyle(item.platformTag || normalizePlatformTag(getMessagePlatform(item)))">
                        {{ (item.platformTag || normalizePlatformTag(getMessagePlatform(item))).label }}
                    </span>
                    <span class="text">{{ item.message }}</span>
                    <!-- <span class="ts">{{ fmt(item.time_stamp) }}</span> -->
                </div>
            </div>
            <div v-for="item in messages" :key="item.id" class="msg">
                <div class="bg" :class="{ 'i-robot': item.client_type == 'clients' }">
                    <span class="uid">{{ displayNickname(item) }}</span>
                    <span class="platform-tag" :style="platformTagStyle(item.platformTag || normalizePlatformTag(getMessagePlatform(item)))">
                        {{ (item.platformTag || normalizePlatformTag(getMessagePlatform(item))).label }}
                    </span>
                    <span class="text">{{ item.message }}</span>
                    <button v-if="!readonlyHistory" class="reply-btn" @click.stop="setReplyTarget(item)">回复</button>
                    <p style="color: rgba(255, 255, 255, 0.5); font-size: 10px;" v-if="watcher">
                        {{ fmt(item.time_stamp) }}
                    </p>
                    <!-- 引用预览区域 -->
                    <div class="reply-line" v-if="item?.reply_to.nickname || item?.reply_to.content_preview">
                        <span class="reply-arrow">↩</span>
                        <span class="reply-user">@{{ item.reply_to.nickname || '匿名' }}</span>
                        <span class="reply-preview-text">
                            {{ item.reply_to.content_preview || '...' }}
                        </span>
                    </div>
                </div>
                <!-- <span class="ts">{{ fmt(item.time_stamp) }}</span> -->
            </div>
            <!-- 长按菜单 -->
            <!-- <div v-if="showMenu" class="action-menu" :style="{ top: menuPos.y + 'px', left: menuPos.x + 'px' }">
                <button @click="pinMessage">置顶</button>
                <button @click="muteUser">禁言</button>
                <button @click="closeMenu">取消</button>
            </div> -->
        </section>
        <slot name="shopify"></slot>

        <!-- 当前回复条 -->
        <div class="reply-bar" v-if="!readonlyHistory && replyTarget">
            <span class="reply-arrow">↩ reply</span>
            <span class="reply-user">@{{ replyTarget.nickname || 'gu_***' }}</span>
            <span class="reply-preview">
                {{ (replyTarget.message || '').slice(0, 30) }}
            </span>
            <button class="reply-cancel" @click="clearReplyTarget">×</button>
        </div>
        <div v-if="readonlyHistory" class="readonly-history-tip">
            历史直播弹幕只读
        </div>
        <footer v-else class="input">
            <slot name="cart" v-if="!watcher">
                <!-- 商品条 -->
                <live-hot-product-bar :visible.sync="showProductBar" />
            </slot>
            <div class="input-danmu">
                <input v-model.trim="input" @keyup.enter="send" :placeholder="placeholder" />
                <button @click="send" :disabled="!input">send</button>
            </div>
            <div class="custom-button">
                <slot></slot>
            </div>
        </footer>
        <!-- 半屏商品列表 -->
        <live-product-list-sheet :visible="showProductList" :products="productList" :active-id="activeProductId"
            @close="showProductList = false" :productList_loading="productList_loading" />
        <!-- <footer class="input">
            <div class="input-danmu">
                <input v-model.trim="input" @keyup.enter="send" :placeholder="placeholder" />
                <button @click="send" :disabled="!input">send</button>
            </div>
        </footer> -->
        <audio ref="ding" src="../assets/634.wav" preload="auto" playsinline muted></audio>
    </div>
</template>

<script>
// 轻量 WS 客户端（心跳 + 重连）—— 内置，亦可独立成 utils
class DanmakuWS {
    constructor(opts = {}) {
        this.url = opts.url; this.roomId = opts.roomId || ''; this.userId = opts.userId || ''; this.token = opts.token || ''; this.appid = opts.appid || 1
        this.heartbeatInterval = opts.heartbeatInterval || 15000; // 15s
        this.heartbeatTimeout = opts.heartbeatTimeout || 60000;  // 6s
        this.reconnectBaseDelay = opts.reconnectBaseDelay || 50000; // 5s
        this.reconnectMaxDelay = opts.reconnectMaxDelay || 120000; // 15s
        this.reconnectMaxAttempts = opts.reconnectMaxAttempts || Infinity;
        this.ws = null; this._hbTimer = null; this._hbTimeoutTimer = null; this._reconnectTimer = null; this._reconnectAttempts = 0; this._manuallyClosed = false;
        this._listeners = new Map();
    }
    on(ev, fn) { if (!this._listeners.has(ev)) this._listeners.set(ev, new Set()); this._listeners.get(ev).add(fn); return () => this.off(ev, fn); }
    off(ev, fn) { this._listeners.get(ev)?.delete(fn); }
    _emit(ev, p) { this._listeners.get(ev)?.forEach(f => { try { f(p) } catch (e) { console.error(e) } }); }

    connect() {
        if (!this.url) throw new Error('url required');
        if (this.ws && this.ws.readyState !== WebSocket.CLOSED) return;
        clearTimeout(this._reconnectTimer);
        this._reconnectTimer = null;
        this._manuallyClosed = false;
        const u = new URL(this.url, window.location.origin);
        if (this.token) u.searchParams.set('api_token', this.token);
        if (this.roomId) u.searchParams.set('stream_id', this.roomId);
        if (this.userId) u.searchParams.set('userId', this.userId);
        if (this.appid) u.searchParams.set('appid', this.appid);
        const ws = new WebSocket(u.toString());
        this.ws = ws;
        ws.onopen = () => this._onOpen();
        ws.onmessage = e => this._onMsg(e);
        ws.onclose = e => this._onClose(e, ws);
        ws.onerror = e => this._emit('error', e);
    }
    _onOpen() {
        this._reconnectAttempts = 0; this._emit('open');
        this._startHB();
    }
    _onMsg(e) {
        let d = e.data;
        if (typeof d === 'string') {
            try { d = JSON.parse(d); } catch (_) { }
        }
        if (d && (d.type === 'pong' || d.type === 'ping' || d.event_type === 'pong' || d.event_type === 'ping')) {
            this._scheduleHB();
            return;
        }
        if (typeof d === 'string') { this._emit('danmaku', { text: d, ts: Date.now() }); return; }
        this._emit('message', d);
        if (d && d.type === 'danmaku') this._emit('danmaku', d);
    }
    _onClose(e, ws) {
        if (this.ws !== ws) return;
        this._clearHB();
        this._emit('close', e);
        this.ws = null;
        if (!this._manuallyClosed) this._reconnect();
    }

    _startHB() {
        this._clearHB();
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
        const ws = this.ws;
        this._hbTimeoutTimer = setTimeout(() => {
            if (this.ws === ws) {
                try { ws.close() } catch (_) { }
            }
        }, this.heartbeatTimeout);
        this._sendPing();
    }
    _scheduleHB() {
        clearTimeout(this._hbTimeoutTimer);
        clearTimeout(this._hbTimer);
        this._hbTimer = setTimeout(() => this._startHB(), this.heartbeatInterval);
    }
    _clearHB() {
        clearTimeout(this._hbTimer);
        this._hbTimer = null;
        clearTimeout(this._hbTimeoutTimer);
        this._hbTimeoutTimer = null;
    }
    _sendPing() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type: 'ping', t: Date.now() }));
        }
    }

    _reconnect() {
        if (this._manuallyClosed) return;
        if (this._reconnectAttempts >= this.reconnectMaxAttempts) return;
        const n = ++this._reconnectAttempts;
        const backoff = Math.min(this.reconnectBaseDelay * Math.pow(2, n - 1), this.reconnectMaxDelay);
        const jitter = Math.random() * 250;
        clearTimeout(this._reconnectTimer);
        this._reconnectTimer = setTimeout(() => {
            this._reconnectTimer = null;
            if (this._manuallyClosed) return;
            this._emit('reconnecting', { attempt: n, delay: backoff + jitter });
            this.connect();
        }, backoff + jitter);
    }

    send(payload) {
        const msg = (typeof payload === 'string') ? payload : JSON.stringify(payload);
        console.log('send-msg-payload=>', msg)
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(msg);
        }
    }
    sendDanmaku(text, replyTarget = null) {
        const payload = {
            type: 'message',
            event_type: 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE',
            roomId: this.roomId,
            userId: this.userId,
            message: text,
            ts: Date.now(),
        };

        // 如果是“回复某条消息”，带上 reply_to 信息
        if (replyTarget && (replyTarget.message || replyTarget.nickname)) {
            const rawText = replyTarget.message || replyTarget.content || '';

            // 可选：直接带一个 reply_to，对端可以原样广播回来
            payload.reply = rawText.slice(0, 50)
            payload.at = replyTarget.nickname || ''
        }
        this.send(payload);
    }
    close() {
        this._manuallyClosed = true;
        this._clearHB();
        clearTimeout(this._reconnectTimer);
        this._reconnectTimer = null;
        const ws = this.ws;
        this.ws = null;
        if (ws) {
            ws.onopen = null;
            ws.onmessage = null;
            ws.onclose = null;
            ws.onerror = null;
            try { ws.close() } catch (_) { }
        }
    }
}
import { getDanmu } from '@/api'
import LiveHotProductBar from '@/components/LiveHotProductBar.vue'
import LiveProductListSheet from '@/components/LiveProductListSheet.vue'

const UNKNOWN_PLATFORM_TAG = { label: 'unknown', backgroundColor: '#475569', color: '#FFFFFF' }
const PLATFORM_TAGS = {
    direct: { label: 'default', backgroundColor: '#64748B', color: '#FFFFFF' },
    app: { label: 'app', backgroundColor: '#FFFFFF', color: '#000000' },
    facebook: { label: 'facebook', backgroundColor: '#1877F2', color: '#FFFFFF' },
    tiktok: { label: 'tiktok', backgroundColor: '#111827', color: '#67E8F9' },
    youtube: { label: 'youtube', backgroundColor: '#FF0033', color: '#FFFFFF' },
    pinterest: { label: 'pinterest', backgroundColor: '#E60023', color: '#FFFFFF' },
    instagram: { label: 'instagram', backgroundColor: '#C13584', color: '#FFFFFF' },
    whatsapp: { label: 'whatsapp', backgroundColor: '#25D366', color: '#111827' },
    messenger: { label: 'messenger', backgroundColor: '#006AFF', color: '#FFFFFF' },
    line: { label: 'line', backgroundColor: '#06C755', color: '#111827' },
    telegram: { label: 'telegram', backgroundColor: '#0088CC', color: '#FFFFFF' },
    reddit: { label: 'reddit', backgroundColor: '#FF4500', color: '#FFFFFF' },
    snapchat: { label: 'snaphat', backgroundColor: '#FFF200', color: '#111827' },
    shopify: { label: 'shopify', backgroundColor: '#95BF47', color: '#132B16' },
    shop: { label: 'shop', backgroundColor: '#0F766E', color: '#FFFFFF' },
}
const PLATFORM_ALIASES = {
    default: 'direct',
    fb: 'facebook',
    tk: 'tiktok',
    yt: 'youtube',
    pin: 'pinterest',
    ins: 'instagram',
    wa: 'whatsapp',
    msg: 'messenger',
    tg: 'telegram',
    rd: 'reddit',
    snap: 'snapchat',
}

function resolvePlatformTag(platform) {
    const raw = String(platform ?? '').trim()
    const lower = raw.toLowerCase()
    const key = PLATFORM_ALIASES[lower] || lower
    const known = PLATFORM_TAGS[key]
    if (known) return { ...known }
    return { ...UNKNOWN_PLATFORM_TAG, label: raw || UNKNOWN_PLATFORM_TAG.label }
}

function resolveMessagePlatform(message) {
    if (!message || typeof message !== 'object') return ''
    return message.platform || message.fromplat || message.from_platform || message.platform_key || ''
}

export default {
    name: 'DanmakuPanel',
    props: {
        url: { type: String, required: true }, // ws(s)://host/danmaku （或 /ws 走代理）
        roomId: { type: [String, Number], required: true },
        userId: { type: String, default: '' },
        token: { type: String, default: '' },
        placeholder: { type: String, default: 'speaking...' },
        // / 是否默认开启提示音（父组件也可通过 :sound-enabled.sync 双向控制）
        soundEnabled: { type: Boolean, default: false },
        soundSrc: {
            type: String,
            default: () =>
                // 内置 60ms 的小“叮”音（wav，体积很小）
                '../assets/643.wav'
        },
        appid: {
            type: Number,
            default: 1
        },
        watcher: {
            type: Boolean,
            default: false
        },
        readonlyHistory: {
            type: Boolean,
            default: false
        },
        danmuTotal: {
            type: [Number, String],
            default: 0
        }
    },
    components: {
        LiveHotProductBar,
        LiveProductListSheet
    },
    watch: {
        roomId(nv, ov) {
            if (nv === ov) return
            this.messages = []
            this.enter_msg = []
            try { this.client?.close() } catch (_) { }
            this.client = null
            this.connectedToken = ''
            this.state = 'idle'
            if (nv && !this.readonlyHistory) this.connectWebSocket(this.token)
            if (nv && this.watcher) this.getDanmuHistory()
        },
        token(nv, ov) {
            if (nv && nv !== ov) {
                this.reconnectWebSocket(nv)
            }
        },
        readonlyHistory(value) {
            if (value) {
                this.clearReplyTarget()
                try { this.client?.close() } catch (_) { }
                this.client = null
                this.connectedToken = ''
                this.state = 'history'
            } else {
                this.connectWebSocket(this.token)
            }
        },
    },
    data() {
        return {
            client: null,
            state: 'idle',
            input: '',
            messages: [],
            _audioUnlocked: false,
            enter_msg: [],
            // 当前正在“回复”的目标消息
            replyTarget: null,
            // 用来给被点击跳转的消息做高亮
            highlightId: null,

            showProductBar: false,
            showProductList: false,
            productList_loading: false,
            historyLoading: false,
            connectedToken: '',
            productList: [
            ],
            activeProductId: 1 // 当前在播商品 id
        };
    },
    mounted() {
        window.addEventListener('admin-token-refreshed', this.handleAdminTokenRefreshed);
        this.init();
        if (this.watcher) {
            this._autoUnlockOnFirstTap();
        }
    },
    beforeDestroy() {
        window.removeEventListener('admin-token-refreshed', this.handleAdminTokenRefreshed);
        try { this.client?.close(); } catch (_) { }
    },
    methods: {
        async init() {
            if (this.readonlyHistory) {
                if (this.watcher) {
                    await this.getDanmuHistory()
                }
                this.state = 'history'
                return
            }
            this.connectWebSocket(this.token)
            if (this.watcher) {
                this.getDanmuHistory()
            }
        },
        connectWebSocket(token = this.token) {
            if (this.readonlyHistory || !this.roomId || !token) return;
            this.connectedToken = token || '';
            this.client = new DanmakuWS({ url: this.url, roomId: this.roomId, token, appid: this.appid });
            this.client.on('open', () => { this.state = 'open'; });
            this.client.on('reconnecting', () => { this.state = 'reconnecting'; });
            this.client.on('close', () => { this.state = 'closed'; });
            this.client.on('message', (m) => {
                this.pushMsg(m);
                // this.$emit('update:onlineCount', m.user_count)
            });
            this.client.connect();
        },
        reconnectWebSocket(token = this.token) {
            if (this.readonlyHistory || !token) return;
            if (token === this.connectedToken && this.client) return;
            try { this.client?.close(); } catch (_) { }
            this.connectWebSocket(token);
        },
        handleAdminTokenRefreshed(event) {
            const token = event?.detail?.token;
            if (token) this.reconnectWebSocket(token);
        },
        async getDanmuHistory() {
            let params = {
                stream_id: this.roomId,
                order: 'asc',
                event_type: 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE',
                per_page: 100
            }
            this.historyLoading = true
            try {
                let { data } = await getDanmu(params)
                let _history = Array.isArray(data?.data) ? data.data : []
                let danmuTotal = _history.filter(f => f.nickname != f.mc_user_name).length
                this.$emit('update:danmuTotal', danmuTotal)
                for (let h of _history) {
                    this.pushMsg(h)
                }
            } catch (err) {
                console.error('[Danmaku] load history failed', err)
                this.$emit('update:danmuTotal', 0)
            } finally {
                this.historyLoading = false
            }
        },
        // 新增：识别“进入直播间”的消息
        isEnterMessage(msg) {
            if (!msg) return false;
            if (typeof msg === 'string') {
                const s = msg.toLowerCase();
                return s.includes('进入直播间') || s.includes('enter') || s.includes('join');
            }
            const t = (msg.type || msg.event || msg.cmd || msg.action || '').toLowerCase();
            if (['enter', 'join', 'user_enter'].includes(t)) return true;
            const text = (msg.text || msg.message || msg.content || '').toLowerCase();
            return text.includes('进入直播间');
        },
        normalizePlatformTag(platform) {
            return resolvePlatformTag(platform);
        },
        getMessagePlatform(item) {
            return resolveMessagePlatform(item);
        },
        platformTagStyle(tag = UNKNOWN_PLATFORM_TAG) {
            return {
                backgroundColor: tag.backgroundColor || UNKNOWN_PLATFORM_TAG.backgroundColor,
                color: tag.color || UNKNOWN_PLATFORM_TAG.color,
            };
        },
        displayNickname(item) {
            return item?.nickname == 'testopen' ? 'GreenbudStore' : (item?.nickname || 'gu_***');
        },
        pushMsg(m) {
            if (!m) return;

            // 心跳之类的不处理
            if (m.event_type === 'pong' || m.event_type === 'ping') return;

            // 进入直播间
            if (m?.event_type == 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_IN_ROOM') {
                this.enter_msg = [];
                this.enter_msg.push({
                    id: m.id || (m.ts + '-' + Math.random().toString(36).slice(2, 6)),
                    ...m,
                    nickname: m.message,
                    message: 'joined',
                    platformTag: this.normalizePlatformTag(this.getMessagePlatform(m)),
                });
            }
            // 普通用户弹幕 / 文本消息
            else if (
                m?.event_type == 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE'
            ) {
                if (m?.client_type !== 'clients') {
                    this.maybeDingOnMessage(m)
                }
                const id = m.id || (m.ts + '-' + Math.random().toString(36).slice(2, 6));
                // 兼容几种可能的字段格式
                const reply_to = {
                    nickname: m.at || '',
                    content_preview: m.reply || '',
                };
                this.messages.push({
                    id,
                    ...m,
                    reply_to,
                    platformTag: this.normalizePlatformTag(this.getMessagePlatform(m)),
                });
            }

            this.$nextTick(() => {
                const el = this.$refs.list;
                if (!el) return;
                el.scrollTop = el.scrollHeight;
            });
        },

        // pushMsg(m) {
        //     if (m && m.type == 'pong' && m.type == 'ping') return
        //     if (m?.event_type == 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_IN_ROOM') {
        //         this.enter_msg = []
        //         this.enter_msg.push({
        //             id: m.event_id || (m.time_stamp + '-' + Math.random().toString(36).slice(2, 6)),
        //             ...m,
        //             message: 'Enter the live broadcast room'
        //         });
        //     } else if (m?.event_type == 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE') {
        //         this.messages.push({
        //             id: m.event_id || (m.time_stamp + '-' + Math.random().toString(36).slice(2, 6)),
        //             ...m,
        //             time_stamp: formatTime(m.time_stamp, 'hh:mm:ss'),
        //         });
        //     }
        //     this.$nextTick(() => { const el = this.$refs.list; if (!el) return; el.scrollTop = el.scrollHeight; });
        // },
        send() {
            if (!this.input) return;
            const text = this.input;
            const currentReply = this.replyTarget; // 先备份
            this.input = '';
            this.replyTarget = null; // 发送后清空引用状态
            this.client?.sendDanmaku(text, currentReply || null);
        },
        fmt(ts) { const d = new Date(ts || Date.now()); return d.toLocaleTimeString().slice(0, 8); },
        maybeDingOnMessage(msg) {
            if (!this.soundEnabled) return;

            // 兼容字符串/JSON
            let t = '';
            if (typeof msg === 'string') {
                t = msg;
            } else if (msg && typeof msg === 'object') {
                // 常见心跳字段名（按你的服务端实际可调整）
                t = String(msg.type || msg.cmd || msg.event || msg.action || '');
            }

            if (t.toLowerCase() === 'pong' || t.toLowerCase() == 'ping') return; // 跳过心跳
            this._playTip();
        },
        async _playTip() {
            const el = this.$refs.ding;
            if (!el) return;
            try {
                el.muted = false;
                console.log('audio muted', el.muted)
            } catch (_) { }
            try {
                el.currentTime = 0;
                console.log(el)

                await el.play();
                console.log('el.play')
            } catch (_) {
                // 若被策略拦截，等待用户下一次点击/触摸解锁即可
            }
        },
        _autoUnlockOnFirstTap() {
            const unlock = () => {
                if (this._audioUnlocked) return;
                const el = this.$refs.ding;
                if (el) {
                    try {
                        el.muted = false;
                        // 播放-立刻暂停，完成解锁
                        el.play().then(() => { el.pause(); this._audioUnlocked = true; })
                            .catch(() => { });
                    } catch (_) { }
                }
                window.removeEventListener('touchend', unlock);
                window.removeEventListener('click', unlock);
            };
            window.addEventListener('touchend', unlock, { once: true, passive: true });
            window.addEventListener('click', unlock, { once: true });
        },
        setReplyTarget(item) {
            if (this.readonlyHistory) return;
            // 设置当前回复对象，用于输入框上方展示
            this.replyTarget = {
                id: item.id,
                nickname: item.nickname,
                message: item.message,
            };
        },

        clearReplyTarget() {
            this.replyTarget = null;
        },

        scrollToMessage(msgId) {
            if (!msgId) return;
            const target = this.messages.find(m => m.id === msgId || m.msg_id === msgId);
            if (!target) return;

            this.highlightId = target.id || target.msg_id;

            // 简单高亮一会儿再取消
            setTimeout(() => {
                if (this.highlightId === this.highlightId) {
                    this.highlightId = null;
                }
            }, 2000);
        },

    }
}
</script>

<style scoped>
.danmaku-panel {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #e8e8e8;
    /* border-radius: 12px; */
    overflow: hidden;
}

.head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #121216;
    border-bottom: 1px solid #1f1f23;
}

.state {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 999px;
    background: #2a2a2e;
}

.state.open {
    background: #10b981;
    color: #001b10;
}

.state.reconnecting {
    background: #f59e0b;
    color: #1b0f00;
}

.state.closed {
    background: #ef4444;
    color: #220000;
}

.list {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: auto;
    padding: 28px 12px 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    /* background: rgba(11, 11, 12, 0.4); */
    position: relative;
}

.enter_msg {
    position: absolute;
    top: 0;
    left: 0;
    line-height: 1.3;
    overflow: hidden;
    padding: 0 12px;
    height: 20px;
    display: flex;
    flex-direction: column-reverse;

}

.enter_msg .msg {
    animation: rightin 0.2s linear;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 0 10px;
    line-height: 20px;
    border-radius: 10px;
}

.history-loading-tip {
    position: sticky;
    top: 0;
    z-index: 2;
    align-self: center;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    padding: 5px 10px;
    border: 1px solid rgba(96, 165, 250, 0.28);
    border-radius: 999px;
    color: #bfdbfe;
    background: rgba(15, 23, 42, 0.82);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    font-size: 12px;
}

@keyframes rightin {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

.msg {
    font-size: 13px;
    line-height: 20px;
}

.msg .bg {
    display: inline-block;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 0 10px;
}

.bg.i-robot {
    background-color: #10b98194;
}

.msg .bg .host {
    background-color: #821dcf;
    border-radius: 10px;
    color: #fff;
    padding: 0 5px;
    margin-right: 5px;
}

.msg .uid {
    color: #a5b4fc;
    margin-right: 6px;
}

.msg .platform-tag {
    display: inline-flex;
    align-items: center;
    min-height: 16px;
    margin-right: 6px;
    padding: 0 6px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 16px;
    font-weight: 700;
    vertical-align: 1px;
}

.msg .text {
    color: #e5e7eb;
    font-weight: 600;
}

.msg .ts {
    color: #9ca3af;
    margin-left: 8px;
    font-size: 11px;
}

.input {
    flex: 0 0 auto;
    display: flex;
    gap: 8px;
    padding: 8px;
    /* background: #121216; */
    /* border-top: 1px solid #1f1f23; */
}

.readonly-history-tip {
    flex: 0 0 auto;
    margin: 8px;
    padding: 9px 12px;
    border: 1px solid rgba(245, 158, 11, 0.32);
    border-radius: 6px;
    color: #fbbf24;
    background: rgba(245, 158, 11, 0.12);
    text-align: center;
    font-size: 13px;
}

.input .input-danmu {
    flex: 1;
    min-width: 0;
    min-height: 40px;
    display: flex;
    border: 1px solid transparent;
    background: rgba(76, 76, 79, 0.3);
    border-radius: 8px;
    align-items: center;
}

.input input {
    font-size: 16px;
    padding: 0 14px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #fff;
    outline: none;
    width: 100%;
}

.input button {
    padding: 0px 4px;
    border-radius: 3px;
    background: #2563eb;
    color: #fff;
    border: none;
    height: 50%;
    line-height: 50%;
    margin-right: 10px;
}

.input .custom-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    line-height: 100%;
    justify-content: space-evenly;
    gap: 8px;
}

::-webkit-scrollbar {
    display: none;
}

/* 列表里引用预览 */
.reply-line {
    font-size: 12px;
    padding: 2px 6px;
    margin-bottom: 2px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
}

.reply-arrow {
    font-size: 12px;
    opacity: 0.8;
}

.reply-user {
    font-weight: 500;
    opacity: 0.9;
    overflow: hidden;
    white-space: nowrap;
}

.reply-preview-text {
    opacity: 0.8;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

/* 列表中“回复”按钮 */
.reply-btn {
    margin-left: 8px;
    font-size: 11px;
    padding: 0 6px;
    border-radius: 3px;
    border: none;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    cursor: pointer;
}

.reply-btn:hover {
    background: rgba(255, 255, 255, 0.15);
}

/* 被定位到的消息高亮 */
.msg.is-highlight .bg {
    box-shadow: 0 0 0 1px #2563eb;
}

/* 输入区上方的回复条 */
.reply-bar {
    flex: 0 0 auto;
    margin: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    margin-bottom: 4px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    font-size: 12px;
}

.reply-bar .reply-preview {
    opacity: 0.8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
}

.reply-cancel {
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
}
</style>
